import { Grid, Typography } from "@material-ui/core";
import CustomEditToolbar from "components/CustomEditToolbar";
import SanitizedGrid from "components/SanitizedGrid";
import React, { useCallback, useState } from "react";
import {
  BooleanInput,
  EditProps,
  SimpleForm,
  TextInput,
  required,
} from "react-admin";
import { GetParam } from "utils/tools";
import CustomAddressAutoCompleteInput from "./components/CustomAddressAutoCompleteInput";
import CustomOneMap from "./components/CustomOneMap";
import LatLngInput from "./components/LatLngInput";
import EditWrapper from "../../components/EditWrapper";

const CcaFixedLocationDropOffEdit = (props: EditProps) => {
  const param = GetParam();
  const [lat, setLat] = useState<number | string | undefined>(0);
  const [lng, setLng] = useState<number | string | undefined>(0);

  const updateMarkerPosition = useCallback(
    ({ type, coordinate }: any) => {
      type === "lat" && setLat(coordinate);
      type === "lng" && setLng(coordinate);
    },
    [setLat, setLng]
  );

  const { id } = props;

  const breadcrumb = [
    { title: "Schools", link: `/schools` },
    { title: "Areas", link: `/schools/${param.get("schoolId")}/show/3` },
    { title: id, link: "" },
  ];

  const setMarker = (value: { lat: string; lng: string }) => {
    setLat(value.lat);
    setLng(value.lng);
  };

  const onMapClick = (data: { lat: number; lng: number }) => {
    setLat(data.lat.toPrecision(15));
    setLng(data.lng.toPrecision(15));
  };

  const transform = async (data: any) => {
    if (data.isActive) {
      data.status = "active";
    } else {
      data.status = "inactive";
    }

    delete data.isActive;

    return data;
  };

  const formatRecord = (res: any) => {
    if (res) {
      res.isActive = res.status === "active";

      return res;
    }
  };

  return (
    <>
      <EditWrapper
        breadcrumb={breadcrumb}
        customName={{
          resourceName: "CCA Fixed Location Drop Off",
          propertyName: "name",
        }}
        transform={transform}
        {...props}
      >
        <SimpleForm
          toolbar={
            <CustomEditToolbar
              redirectLink={`/schools/${param.get("schoolId")}/show/3`}
            />
          }
          initialValues={formatRecord}
        >
          <SanitizedGrid container spacing={2}>
            <Grid item xs={4}>
              <TextInput source="name" validate={required()} />
            </Grid>
            <Grid item xs={8}></Grid>

            <Grid item xs={4}>
              <CustomAddressAutoCompleteInput
                label="Postal Code *"
                source="postalCode"
                referenceSource="ccaLocationData"
                parentCallback={setMarker}
              />
            </Grid>
            <Grid item xs={8}></Grid>

            <Grid item xs={2}>
              <TextInput label="Unit No." source="unitNumber" />
            </Grid>
            <Grid item xs={2}>
              <TextInput
                label="Block No."
                source="blockNumber"
                validate={required()}
              />
            </Grid>
            <Grid item xs={8}></Grid>

            <Grid item xs={4}>
              <TextInput label="Building Name" source="building" />
            </Grid>
            <Grid item xs={8}></Grid>

            <Grid item xs={4}>
              <TextInput
                label="Address"
                source="address"
                validate={required()}
              />
            </Grid>
            <Grid item xs={8}></Grid>

            <Grid item xs={4}>
              <TextInput label="Street" source="street" validate={required()} />
            </Grid>
            <Grid item xs={8}></Grid>

            <Grid item xs={12}>
              <Typography variant="h6">
                Map Location (Location for fixed location drop off)
              </Typography>
            </Grid>

            <Grid item xs={6}>
              {lat !== 0 && lng !== 0 && (
                <CustomOneMap center={{ lat, lng }} onMapClick={onMapClick} />
              )}
            </Grid>
            <Grid item xs={6}></Grid>

            <Grid item xs={4}>
              <LatLngInput
                lat={lat}
                lng={lng}
                updateLatLng={updateMarkerPosition}
              />
            </Grid>
            <Grid item xs={8}></Grid>

            <Grid item xs={6}>
              <BooleanInput
                source="isActive"
                label="Set this fixed location drop off as Active"
              />
            </Grid>
          </SanitizedGrid>
        </SimpleForm>
      </EditWrapper>
    </>
  );
};

export default CcaFixedLocationDropOffEdit;
